// Generated by CoffeeScript 1.11.1
(function() {
  var Color;

  Color = require('../color');

  module.exports = {
    setCmykChannels: function() {
      this.channelsInfo = [
        {
          id: 0
        }, {
          id: 1
        }, {
          id: 2
        }, {
          id: 3
        }
      ];
      if (this.channels() === 5) {
        return this.channelsInfo.push({
          id: -1
        });
      }
    },
    combineCmykChannel: function() {
      var a, b, c, chan, cmykChannels, g, i, index, j, k, l, len, m, r, ref, ref1, val, y;
      cmykChannels = this.channelsInfo.map(function(ch) {
        return ch.id;
      }).filter(function(ch) {
        return ch >= -1;
      });
      for (i = j = 0, ref = this.numPixels; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        c = m = y = k = 0;
        a = 255;
        for (index = l = 0, len = cmykChannels.length; l < len; index = ++l) {
          chan = cmykChannels[index];
          val = this.channelData[i + (this.channelLength * index)];
          switch (chan) {
            case -1:
              a = val;
              break;
            case 0:
              c = val;
              break;
            case 1:
              m = val;
              break;
            case 2:
              y = val;
              break;
            case 3:
              k = val;
          }
        }
        ref1 = Color.cmykToRgb(255 - c, 255 - m, 255 - y, 255 - k), r = ref1[0], g = ref1[1], b = ref1[2];
        this.pixelData.set([r, g, b, a], i * 4);
      }
      return this.readMaskData(cmykChannels);
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/image_modes/cmyk.js
// module id = 43
// module chunks = 0